const en = {
  // Header
  'header.brand': 'FlashSync',
  'header.tagline': 'Encrypted browser sync',
  'header.home': 'Home',
  'header.dashboard': 'Dashboard',
  'header.settings': 'Settings',
  'header.signedInAs': 'Signed in as',
  'header.logout': 'Logout',
  'header.login': 'Login',
  'header.getStarted': 'Get Started',

  // Home
  'home.eyebrow': 'Private browser sync',
  'home.heading': 'Modern, encrypted sync for bookmarks, passwords, and notes.',
  'home.subtitle': 'FlashSync gives you a polished self-hosted alternative to cloud browser sync, with end-to-end encryption, Chrome extension capture, and a web dashboard that stays in your control.',
  'home.trustZeroKnowledge': 'Zero-knowledge',
  'home.trustZeroKnowledgeDesc': 'Encrypted before upload',
  'home.trustImport': 'Chrome CSV import',
  'home.trustImportDesc': 'Bring your existing passwords',
  'home.trustSelfHosted': 'Self-hosted ready',
  'home.trustSelfHostedDesc': 'Own the server and the data',
  'home.feature1Heading': 'Client-side encryption for everything sensitive',
  'home.feature1Body': 'Passwords, bookmarks, and notes stay encrypted before they leave your browser, so the server only stores ciphertext and sync metadata.',
  'home.feature2Heading': 'Extension-first onboarding with guided install steps',
  'home.feature2Body': 'Download the packaged extension, load it in Chrome, sign in once, and start syncing from the same account you use on the web dashboard.',
  'home.feature3Heading': 'Bring your Chrome-exported passwords in minutes',
  'home.feature3Body': 'Review import previews, merge into your vault, and keep plaintext only in transient browser memory until it is encrypted locally.',
  'home.feature1Badge': 'Security first',
  'home.feature2Badge': 'Fast setup',
  'home.feature3Badge': 'Flexible import',
  'home.sharperHeading': 'A sharper experience without giving up privacy.',
  'home.whyHeading': 'Why teams and individuals use FlashSync',
  'home.whyBody': 'The redesigned product focuses on clarity, speed, and strong visual hierarchy while keeping the current encrypted workflows intact.',
  'home.installIntroHeading': 'Download the Chrome extension and go live quickly.',
  'home.installHeading': 'Extension install',
  'home.installBody': 'Grab the current packaged ZIP from this site, extract it locally, and load it as an unpacked extension. Once installed, FlashSync can capture passwords, sync bookmarks, and manage notes.',
  'home.installStep1': 'Download and unzip the extension package.',
  'home.installStep2': 'Open chrome://extensions.',
  'home.installStep3': 'Enable Developer mode.',
  'home.installStep4': 'Click Load unpacked and select the extracted folder.',
  'home.installInChrome': 'Install in Chrome',
  'home.ctaHeading': 'Ready to switch?',
  'home.ctaBody': 'Create your account, install the extension, and manage everything from one attractive dashboard.',
  'home.bottomHeading': 'Turn the plain browser sync workflow into a polished encrypted vault.',
  'home.launchVault': 'Launch your vault',
  'home.downloadZip': 'Download extension ZIP',
  'home.viewSource': 'View source',
  'home.downloadBtn': 'Download flashsync-chrome-extension.zip',
  'home.createAccount': 'Create an account',
  'home.startWith': 'Start with FlashSync',
  'home.existingAccount': 'I already have an account',
  'home.cardVault': 'Vault sync',
  'home.cardVaultSub': 'Bookmarks, passwords, notes',
  'home.cardVaultDesc': 'One encrypted workflow across extension and dashboard.',
  'home.cardBookmarks': 'Bookmarks mirrored',
  'home.cardPasswords': 'Passwords imported',
  'home.cardControl': 'Under your control',
  'home.installInChrome': 'Install in Chrome',

  // Login
  'login.eyebrow': 'Welcome back',
  'login.heading': 'Unlock your encrypted FlashSync workspace.',
  'login.body': 'Sign in to access bookmarks, notes, and your password vault from the redesigned dashboard.',
  'login.benefit1Heading': 'Zero-knowledge access',
  'login.benefit1Body': 'Your data is decrypted client-side after login.',
  'login.benefit2Heading': 'Unified vault',
  'login.benefit2Body': 'Manage bookmarks, passwords, and notes in one place.',
  'login.formHeading': 'Login to FlashSync',
  'login.formBody': 'Use your account credentials and server endpoint to continue.',
  'login.email': 'Email',
  'login.password': 'Password',
  'login.serverURL': 'Server URL',
  'login.advancedShow': 'Show advanced settings',
  'login.advancedHide': 'Hide advanced settings',
  'login.serverHelp': 'Point FlashSync to your hosted or self-managed server.',
  'login.btn': 'Login',
  'login.loading': 'Logging in...',
  'login.noAccount': 'Need an account? Create one',
  'login.enterAll': 'Please enter both email and password',
  'login.enterServer': 'Please enter a server URL',

  // Register
  'register.eyebrow': 'Create your vault',
  'register.heading': 'Start a private sync space that looks as good as it feels.',
  'register.body': 'Register once, connect your server, and use the same account for the extension and the new dashboard.',
  'register.benefit1Heading': 'Bring your existing data',
  'register.benefit1Body': 'Import Chrome passwords and keep bookmarks plus notes in sync.',
  'register.benefit2Heading': 'Host it yourself',
  'register.benefit2Body': 'Use your own backend and keep full control over infrastructure.',
  'register.formHeading': 'Create FlashSync Account',
  'register.formBody': 'Choose your credentials and connect this client to your preferred FlashSync server.',
  'register.email': 'Email',
  'register.password': 'Password',
  'register.confirmPassword': 'Confirm Password',
  'register.serverURL': 'Server URL',
  'register.advancedShow': 'Show advanced settings',
  'register.advancedHide': 'Hide advanced settings',
  'register.serverHelp': 'Point FlashSync to your hosted or self-managed server.',
  'register.btn': 'Create account',
  'register.loading': 'Registering...',
  'register.hasAccount': 'Already have an account? Login',
  'register.fillAll': 'Please fill in all fields',
  'register.passwordsMatch': 'Passwords do not match',
  'register.enterServer': 'Please enter a server URL',
  'register.success': 'Registration successful! Please login.',

  // Dashboard
  'dashboard.passwords': 'Passwords',
  'dashboard.bookmarks': 'Bookmarks',
  'dashboard.notes': 'Notes',
  'dashboard.total': 'Total',
  'dashboard.totalItems': 'Total Items',
  'dashboard.lastSync': 'Last Sync:',
  'dashboard.never': 'Never',
  'dashboard.loading': 'Loading data...',
  'dashboard.decryptingPasswords': 'Decrypting passwords...',
  'dashboard.decryptingBookmarks': 'Decrypting bookmarks...',
  'dashboard.decryptingNotes': 'Decrypting notes...',
  'dashboard.decrypting': 'Decrypting...',
  'dashboard.passwordVault': 'Password Vault',
  'dashboard.yourBookmarks': 'Your Bookmarks',
  'dashboard.secretNotes': 'Secret Notes',
  'dashboard.importCSV': 'Import Chrome CSV',
  'dashboard.addPassword': 'Add Password',
  'dashboard.addNote': 'Add Note',
  'dashboard.unlockVault': 'Unlock Vault',
  'dashboard.decrypt': 'Decrypt',
  'dashboard.cancel': 'Cancel',
  'dashboard.import': 'Import',
  'dashboard.importing': 'Importing...',
  'dashboard.save': 'Save',
  'dashboard.saving': 'Saving...',
  'dashboard.delete': 'Delete',
  'dashboard.hide': 'Hide',
  'dashboard.show': 'Show',
  'dashboard.untitledPassword': 'Untitled Password',
  'dashboard.noUsername': '(No username)',
  'dashboard.searchPlaceholder': 'Search by site or username',
  'dashboard.noPasswordsMatch': 'No passwords match your search.',
  'dashboard.noPasswordsYet': 'No passwords have been synced yet.',
  'dashboard.noPasswordsHint': 'Add one manually here, import a Chrome CSV export, or sync from the extension.',
  'dashboard.noBookmarks': 'No bookmarks found.',
  'dashboard.noBookmarksHint': 'Use the Chrome extension to sync your bookmarks.',
  'dashboard.noNotes': 'No notes have been synced yet.',
  'dashboard.noNotesHint': 'Create one here or use the Chrome extension and sync it back.',
  'dashboard.importPreview': 'Ready to import {count} rows: {additions} new and {updates} updates.',
  'dashboard.importSkipped': 'Skipped {count} invalid rows from the CSV.',
  'dashboard.unlockPasswords': 'Enter your master password to decrypt, edit, and import your synced passwords in the browser.',
  'dashboard.unlockBookmarks': 'Enter your master password to decrypt your synced bookmark data in the browser.',
  'dashboard.unlockNotes': 'Enter your master password to decrypt and edit your synced secret notes.',
  'dashboard.enterMasterPassword': 'Enter Master Password',
  'dashboard.unlockPrompt': 'Please enter your master password to unlock your encrypted passwords, bookmarks, and notes.',
  'dashboard.masterPassword': 'Master Password',
  'dashboard.newNote': 'New Note',
  'dashboard.editNote': 'Edit Note',
  'dashboard.noteTitle': 'Title',
  'dashboard.noteTitlePlaceholder': 'Optional title',
  'dashboard.noteContent': 'Secret text',
  'dashboard.noteContentPlaceholder': 'Write your note here',
  'dashboard.untitledNote': 'Untitled Note',
  'dashboard.emptyNote': 'Empty note',
  'dashboard.newPassword': 'New Password',
  'dashboard.editPassword': 'Edit Password',
  'dashboard.passwordTitle': 'Title',
  'dashboard.passwordTitlePlaceholder': 'Optional title',
  'dashboard.passwordURL': 'Website URL',
  'dashboard.passwordURLPlaceholder': 'https://example.com/login',
  'dashboard.passwordUsername': 'Username',
  'dashboard.passwordUsernamePlaceholder': 'alice@example.com',
  'dashboard.passwordField': 'Password',
  'dashboard.passwordPlaceholder': 'Required',
  'dashboard.hidePassword': 'Hide password',
  'dashboard.showPassword': 'Show password',
  'dashboard.decryptBookmarksFailed': 'Failed to decrypt bookmarks. Please try again.',
  'dashboard.decryptNotesFailed': 'Failed to decrypt notes. Please try again.',
  'dashboard.decryptPasswordsFailed': 'Failed to decrypt passwords. Please try again.',
  'dashboard.loadSyncFailed': 'Failed to load sync data. Please try again later.',
  'dashboard.saltFailed': 'Failed to retrieve encryption salt from server.',
  'dashboard.invalidPassword': 'Invalid master password or failed to decrypt data.',
  'dashboard.notesConflict': 'Notes changed on another device. The latest encrypted notes were loaded; please review and try again.',
  'dashboard.saveNotesFailed': 'Failed to save notes. Please try again.',
  'dashboard.enterNoteContent': 'Please enter a title or note content before saving.',
  'dashboard.passwordsConflict': 'Passwords changed on another device. The latest encrypted vault was loaded; please review and try again.',
  'dashboard.savePasswordsFailed': 'Failed to save passwords. Please try again.',
  'dashboard.enterURLPassword': 'Please enter both a website URL and password before saving.',
  'dashboard.parseFailed': 'Failed to parse password import file.',
  'dashboard.serverSaltMissing': 'Server did not return an encryption salt',

  // Settings
  'settings.general': 'General settings',
  'settings.changePassword': 'Change password',
  'settings.account': 'Account',
  'settings.generalDesc': 'Manage where this client connects and how frequently it syncs.',
  'settings.changePasswordDesc': 'Rotate your account credentials without leaving the dashboard.',
  'settings.signedInAs': 'Signed in as',
  'settings.serverURL': 'Server URL',
  'settings.serverURLHelp': 'The URL of your FlashSync server.',
  'settings.save': 'Save settings',
  'settings.saving': 'Saving...',
  'settings.currentPassword': 'Current password',
  'settings.newPassword': 'New password',
  'settings.confirmNewPassword': 'Confirm new password',
  'settings.changePasswordBtn': 'Change password',
  'settings.changing': 'Changing...',
  'settings.logout': 'Logout',
  'settings.savedSuccess': 'Settings saved successfully',
  'settings.passwordChanged': 'Password changed successfully',
  'settings.loadFailed': 'Failed to load settings. Please try again.',
  'settings.saveFailed': 'Failed to save settings. Please try again.',
  'settings.passwordMismatch': 'New passwords do not match',
  'settings.changeFailed': 'Failed to change password. Please try again.',

  // 404
  'notfound.eyebrow': 'Lost in transit',
  'notfound.heading': 'The page you requested isn\'t part of this vault.',
  'notfound.body': 'It may have moved, the link may be outdated, or the route simply does not exist in this FlashSync build.',
  'notfound.returnHome': 'Return home',
  'notfound.openDashboard': 'Open dashboard',

  // Footer
  'footer.tagline': 'Zero-knowledge sync',
  'footer.brand': 'FlashSync',
  'footer.desc': 'A polished, self-hosted home for encrypted bookmarks, passwords, and notes across your devices.',
  'footer.product': 'Product',
  'footer.access': 'Access',
  'footer.resources': 'Resources',
  'footer.overview': 'Overview',
  'footer.dashboard': 'Dashboard',
  'footer.settings': 'Settings',
  'footer.login': 'Login',
  'footer.createAccount': 'Create account',
  'footer.downloadExt': 'Download extension',
  'footer.sourceCode': 'Source code',
  'footer.deployDocs': 'Deployment docs',
  'footer.projectUpdates': 'Project updates',
  'footer.copyright': 'Built for private browser sync with end-to-end encryption.',

  // Language
  'lang.en': 'EN',
  'lang.zhCN': '中',
};

export default en;
